import { Box } from "@nulogy/components";
import Input from "components/controls/Input";
import Select from "components/controls/Select";
import DowntimeBlock from "domain/DowntimeBlock";
import { useFormikContext } from "formik";
import React, { useState } from "react";

const inputType = (isCustom) => {
  if (isCustom) return "text";

  return "hidden";
};

const hasCustomReason = (downtime) => downtime && downtime.reasonCode === null;

export default function DowntimeReasonSelect({
  downtimeBlock,
  lockedOnSchedule,
  downtimeReasonsData,
  downtimeReasonsLoading,
}) {
  const [isCustom, setIsCustom] = useState(hasCustomReason(downtimeBlock));
  const { setFieldValue, setFieldTouched } = useFormikContext();

  if (downtimeReasonsLoading) return null;

  const { downtimeReasons } = downtimeReasonsData;

  const options = downtimeReasons.map((reason) => {
    const reasonDescription = DowntimeBlock.reasonDescription({ reason: reason.reason, reasonCode: reason.code });

    return {
      label: reasonDescription,
      value: reason.code,
    };
  });

  options.push({ label: "Custom reason", value: null });

  if (downtimeBlock?.reasonCode) {
    const reasonDescription = DowntimeBlock.reasonDescription(downtimeBlock);
    const matchingDowntimeReason = (option) =>
      option.value === downtimeBlock.reasonCode && option.label === reasonDescription;

    if (!options.find(matchingDowntimeReason)) {
      options.unshift({ label: reasonDescription, value: downtimeBlock.reasonCode });
    }
  }

  const handleDowntimeReasonChange = ({ value }) => {
    setIsCustom(value === null);

    if (value !== null) {
      const reason = downtimeReasons.find((downtimeReason) => downtimeReason.code === value);
      setFieldValue("reason", reason.reason);
    } else {
      setFieldValue("reason", "");
      setTimeout(() => setFieldTouched("reason", true), 100);
    }
  };

  const enableDropdown = options.length > 1;

  return (
    <>
      {enableDropdown && (
        <>
          <Select
            disabled={lockedOnSchedule}
            field="reasonCode"
            labelText="Reason"
            maxHeight="250"
            onChange={handleDowntimeReasonChange}
            options={options}
            required
          />
          <Box marginBottom={isCustom && "x2"}>
            <Input data-testid="reason-input" disabled={lockedOnSchedule} field="reason" type={inputType(isCustom)} />
          </Box>
        </>
      )}
      {!enableDropdown && (
        <Box marginBottom="x2">
          <Input data-testid="reason-input" disabled={lockedOnSchedule} field="reason" labelText="Reason" />
        </Box>
      )}
    </>
  );
}
